import React, {useEffect, useState} from "react";
import EuroLogo from "../../../assets/images/eoro-2024/Euro-2024-Logo.svg";


const EuroInstructions = (props) => {
    const {isMobile} = props;

    const renderMobile = () => {
        return (
            <>
                <div className={"d-flex align-items-center justify-content-center"}>
                    <div className={"w-100 d-flex flex-column align-items-center justify-content-center gap-1"}>
                        <img
                            src={EuroLogo}
                            className="img-fluid"
                            alt="Euro 2024"
                        />
                        {/*<div className={"cabin fw-500 font-25 text-skins-blue"}>*/}
                        {/*    Euro 2024 Group Winners*/}
                        {/*</div>*/}
                        <div className={"cabin fw-700 font-25 text-skins-red text-uppercase my-2"}>
                            INSTRUCTIONS
                        </div>
                        <div className={"d-flex align-items-center flex-column cabin fw-400 font-10 text-center text-skins-blue"}>
                            <div>1. Select your Golden Team and enter it into the Gold Coloured box </div>
                            <div>2. Pick top and bottom from each group</div>
                            <div>3. Enter your tie break prediction( Total tournament goals including Extra Time but not including penalty shoot outs)</div>
                        </div>
                    </div>
                </div>

            </>
        );
    }

    const renderDesktop = () => {
        return (
            <>
                <div className={"d-flex align-items-center justify-content-center"}>
                    <div className={"w-100 d-flex flex-column align-items-center justify-content-center gap-1"}>
                        <img
                            src={EuroLogo}
                            className="img-fluid"
                            alt="Euro 2024"
                        />
                        {/*<div className={"cabin fw-400 font-60 text-skins-blue"}>*/}
                        {/*    Euro 2024 Group Winners*/}
                        {/*</div>*/}
                        <div className={"cabin fw-700 font-25 text-skins-red text-uppercase my-2"}>
                            INSTRUCTIONS
                        </div>
                        <div className={"d-flex align-items-center flex-column cabin fw-400 font-20 text-skins-blue"}>
                            <div>1. Select your Golden Team and enter it into the Gold Coloured box </div>
                            <div>2. Pick top and bottom from each group</div>
                            <div>3. Enter your tie break prediction( Total tournament goals including Extra Time but not including penalty shoot outs)</div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
    const render = () => {
        return (
            <section
            >
                {isMobile ? renderMobile() : renderDesktop()}
            </section>
        );
    }

    return render();
}

export default EuroInstructions;
